export const setCookie = async (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    if (!('cookieStore' in window)) {
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    } else {
        try {
            await cookieStore.set({
                name: cname,
                value: cvalue,
                expires: Date.now() + exdays * 24 * 60 * 60 * 1000,
                path: '/'
            });
        } catch (error) {
            console.log(`Error setting cookie: ${error}`);
        }
    }
    
    window.dataLayer.push({ occ: cvalue, event: 'onconsent' });
};

export const getCookie = async (cname) => {
    if (!('cookieStore' in window)) {
        let name = cname + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
    } else {
        let cookie = await cookieStore.get(cname);
        if (cookie) {
            return cookie.value;
        }
    }

    return '';
};
